export default __webpack_public_path__ + "5a66c66dfba3ca9e39cafd84b2e7ab7b.svg";